import { useContext } from 'react';
import { RequestDetailsViewContext } from './context';

export const useRequestDetailsView = () => {
  const context = useContext(RequestDetailsViewContext);

  if (!context) throw new Error('useRequestDetailsView must be used within a RequestDetailsViewProvider');

  return context;
};
